import { render } from "./ChatDrawer.vue?vue&type=template&id=655ee0d0&scoped=true"
import script from "./ChatDrawer.vue?vue&type=script&lang=js"
export * from "./ChatDrawer.vue?vue&type=script&lang=js"

import "./ChatDrawer.vue?vue&type=style&index=0&id=655ee0d0&lang=scss&scoped=true"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655ee0d0"]])

export default __exports__